import type { AttachmentType } from '@mimir/common/dto/attachmentPrimitives';
export type PosterFrameProcessingType = 'upload' | 'capture' | 'none';

export interface ItemAttachmentUploadState {
  itemId: string;
  fileName: string;
  progress: number;
  type: AttachmentType;
}

export type OngoingItemAttachmentUploads = Record<string, ItemAttachmentUploadState | undefined>;

export const getOngoingAttachmentUploadKey = (itemId: string, type: AttachmentType, fileName: string) => `${itemId}_${type}_${fileName}`;
